'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});
function ChooseSeatController(Currencies, $rootScope, PaymentComponent, $stateParams, TicketComponent, ReturnSubLine, SubLine, $state, ValidationService, ClientComponent, DiscountComponent, SubLineComponent, Toast, $filter, $document, $window, $scope) {
	'ngInject';

	var vm = this;
	var publicPage = angular.element(document.getElementById('publicParrent'));
	var leftAside = angular.element(document.getElementById('chooseLeftAside'));
	vm.subLine = SubLine;
	vm.returnSubLine = ReturnSubLine;
	vm.selectSeat = selectSeat;
	vm.goToBusSchema = goToBusSchema;
	vm.goingSeat = null;
	vm.returnSeat = null;
	vm.getDiscounts = DiscountComponent.getDiscounts;
	vm.discount = { 'translation': { 'name': $filter('translate')('WITHOUT_DISCOUNT') } };
	vm.discountId = null;
	vm.submitTicketInformation = submitTicketInformation;
	vm.numberValidation = ValidationService.numberValidation;
	vm.textValidation = ValidationService.textValidation;
	vm.emailValidation = ValidationService.emailValidation;
	vm.phoneValidation = ValidationService.phoneValidation;
	vm.unavailableSeats = vm.subLine.seats;
	vm.unavailableReturnSeats = vm.returnSubLine ? vm.returnSubLine.seats : [];
	vm.seats = [];
	vm.returnSeats = [];
	vm.chooseDiscount = chooseDiscount;
	vm.ticket = {};
	$scope.schemaType = $window.outerWidth < 1024 ? 'vertical' : 'horizontal';
	vm.disableReserveButton = false;
	vm.ticketPrice = [];
	vm.showTerms = false;
	vm.enabledButton = false;

	setExternalUser();
	init();

	$rootScope.$on('$translateChangeSuccess', function () {
		SubLineComponent.fetchSubLine($stateParams.subLineId, $stateParams.busId, $stateParams.date).then(function (res) {
			vm.subLine = res;
		});
		if ($stateParams.returnId) {
			SubLineComponent.fetchSubLine($stateParams.returnId, $stateParams.returnBusId, $stateParams.returnDate).then(function (res) {
				vm.returnSubLine = res;
			});
		}
	});

	/** */
	function init() {
		// check if the vm.subline returns error, when the link is generated from external website with not matching data
		// - show error messege from the server and redirect to home
		// no error fetched object -> {'id': x, 'line_id': x, 'created_at': 'xxxx-xx-xx',...}
		// error fetched object -> {'data': {'errors': {'error_key': ['error']}}, ...}
		if (vm.subLine.data) {
			Toast.responseError(vm.subLine.data.errors);
			$state.go('app.public.btms.home');
		}

		if ($stateParams.lang) {
			$scope.$parent.vm.changeLocale($stateParams.lang);
		}

		changeUnavailableSeatColor();
		ticketPrice();

		// Change busSchema orientation on smaller devices
		$window.addEventListener('resize', function () {
			schemaOrientationChange();
		});

		// Scroll top when enter state
		$document.scrollTo(publicPage, 0, 0);
	}

	/** */
	function schemaOrientationChange() {
		if ($window.outerWidth <= 650) {
			$scope.$apply(function () {
				$scope.schemaType = 'vertical';
			});
		} else {
			$scope.$apply(function () {
				$scope.schemaType = 'horizontal';
			});
		}
	}

	/** */
	function goToBusSchema(schemaId) {
		var schema = angular.element(document.getElementById(schemaId));
		$document.scrollTo(schema, 140, 500);
	}

	/** */
	function chooseDiscount(discount) {
		var discountValue = null;

		if (!discount) {
			vm.discountId = null;
			vm.discount = { 'translation': { 'name': $filter('translate')('WITHOUT_DISCOUNT') } };

			return ticketPrice();
		} else {
			(function () {
				vm.discountId = discount.id;
				vm.discount.translation.name = discount.translation.name + ' - ' + discount.value + ' ' + (discount.type === 'percent' ? '%' : $filter('translate')('CURRENCIES.BGN')) + '  ';

				var value = null;
				discountValue = parseInt(discount.value, 10);

				ticketPrice().forEach(function (currency, index) {
					if (discount.type === 'value') {
						value = currency.value - discountValue / Currencies[index].exchange_rate;
						currency.value = value.toFixed(2);

						return vm.ticketPrice;
					} else {
						value = currency.value - currency.value / 100 * discountValue;
						currency.value = value.toFixed(2);

						return vm.ticketPrice;
					}
				});
			})();
		}
	}

	/** */
	function selectSeat(seat, direction) {
		if (seat.active && seat.color !== 'choosen') {
			Toast.error($filter('translate')('ERRORS.TAKEN_SEAT'));
			return false;
		} else if (seat.color === 'choosen') {
			Toast.error($filter('translate')('ERRORS.CHOOSEN_SEAT'));
		}

		if (direction === 'going') {
			vm.seats.forEach(function (item) {
				if (item.active && item.status === 'free') {
					item.active = false;
					item.color = 'free';
				}
			});
		} else {
			vm.returnSeats.forEach(function (item) {
				if (item.active && item.status === 'free') {
					item.active = false;
					item.color = 'free';
				}
			});
		}

		if (!seat.active) {
			seat.active = true;
			seat.color = 'choosen';
			if (direction === 'going') {
				vm.goingSeat = seat.number;
			} else {
				vm.returnSeat = seat.number;
			}
			if ($window.outerWidth < 1024) {
				$document.scrollTo(leftAside, 100, 500);
			}
		}
	}

	/** */
	function changeUnavailableSeatColor() {
		if (vm.unavailableSeats.length) {
			vm.unavailableSeats.forEach(function (item) {
				item.active = false;
				item.color = 'unavailable';
			});
		}

		if (vm.unavailableReturnSeats.length) {
			vm.unavailableReturnSeats.forEach(function (item) {
				item.active = false;
				item.color = 'unavailable';
			});
		}
	}

	/** */
	function submitTicketInformation(client) {
		var hasErrors = false;
		vm.disableReserveButton = true;

		if ($scope.chooseSeat.$error.required) {
			hasErrors = true;
			// return false;
		}

		if (hasErrors) {
			Toast.error($filter('translate')('ERRORS.GENERAL'));
			vm.disableReserveButton = false;

			return false;
		}

		if (vm.textValidation(vm.client.names) && vm.numberValidation(vm.client.id_number) && vm.emailValidation(vm.client.email)) {

			ClientComponent.createClient(client).then(function (res) {
				if (res.data.errors) {
					Toast.responseError(res.data.errors);
					vm.disableReserveButton = false;
				} else {
					submitSeatReseservation(res.data.data.id);
				}
			});
		}
	}

	/** */
	function submitSeatReseservation(clientId) {
		var ticket = {
			'client_id': clientId,
			'discount_id': vm.discountId,
			'status': 'reserved',
			'seats': [{
				'bus_id': SubLine.bus.id,
				'sub_line_id': SubLine.id,
				'number': vm.goingSeat,
				'arrives_at': SubLine.bus.arrives_at,
				'departs_at': SubLine.bus.departs_at
			}],
			'is_public': true
		};

		// Sets the external user that sells this ticket (a.k.a BgRazpisanie)
		// Could be different external user than BgRazpisanie
		if ($stateParams.u) {
			ticket.u = $stateParams.u;
		} else if ($window.sessionStorage.user) {
			ticket.u = $window.sessionStorage.user;
		}

		if (ReturnSubLine) {
			var returnTicket = {
				'bus_id': ReturnSubLine.bus.id,
				'sub_line_id': ReturnSubLine.id,
				'number': vm.returnSeat,
				'arrives_at': ReturnSubLine.bus.arrives_at,
				'departs_at': ReturnSubLine.bus.departs_at
			};

			ticket.seats.push(returnTicket);
		}

		if (!vm.discountId) {
			delete ticket.discount_id;
		}

		TicketComponent.createTicket(ticket).then(function (res) {
			if (res.data.errors) {
				Toast.responseError(res.data.errors);
				vm.disableReserveButton = false;
			} else {
				vm.ticket = res.data.data;
				$state.go('app.public.btms.buy-ticket', { 'ticketId': vm.ticket.id, 'ticketPrice': vm.ticketPrice });
			}
		});
	}

	/** Create price object set value and currency code
  * @return { Object } - vm.ticketPrice - Ticket price in different currencies
 */
	function ticketPrice() {
		vm.ticketPrice = [];
		var price = {};

		for (var i = 0, max = vm.subLine.currencies.length; i < max; i++) {
			var oneWayTicket = vm.subLine.currencies[i];
			var returnTicket = vm.returnSubLine ? vm.returnSubLine.currencies[i] : 0;
			var exchangeRate = Currencies[i].exchange_rate;

			price = {

				'value': sumPrice(oneWayTicket, returnTicket, exchangeRate),
				'code': vm.subLine.currencies[i].code
			};

			vm.ticketPrice.push(price);
		}

		return vm.ticketPrice;
	}

	/** Calculate ticket price
  * @params { Array } - oneWayTicket - going line
  * @params { Array } - returnTicket - return line
  * @return { Number } calculatedPrice - final calculated price
  */
	function sumPrice(oneWayTicket, returnTicket, rate) {
		var returnTicketDiscount = vm.subLine.return_ticket_discount;
		var calculatedPrice = '';
		var discount = null;

		if (returnTicketDiscount.hasOwnProperty('type') && returnTicketDiscount.type === 'value') {
			discount = returnTicketDiscount.value / rate;
			if (returnTicket === 0) {
				calculatedPrice = oneWayTicket.value;
			} else {
				calculatedPrice = oneWayTicket.value + returnTicket.value - discount;
			}
		} else {
			discount = returnTicketDiscount.value / rate;

			if (returnTicket === 0) {
				calculatedPrice = oneWayTicket.value;
			} else {
				var totalPrice = oneWayTicket.value + returnTicket.value;

				calculatedPrice = totalPrice - totalPrice / 100 * discount;
			}
		}

		return calculatedPrice.toFixed(2);
	}

	// set external user value from the url to the session storage
	function setExternalUser() {
		if ($state.params.u) {
			$window.sessionStorage.setItem('user', $state.params.u);
		}
	}
}

exports['default'] = ChooseSeatController;
module.exports = exports['default'];


/** WEBPACK FOOTER **
 ** ./client/public/main/choose-seat/choose-seat.controller.js
 **/